import React from "react";
import { Modal, ModalBody } from 'reactstrap';
import { ReactSession } from "react-client-session";
import { toast } from 'react-toastify';

import { Helpers } from "../config/Helpers";

class ModalLokasi extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            isModalOpen: false,
            loading: true,
            lokasiData: [],
            search: '',
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : '',
            kodeLokasi: (ReactSession.get("sess_order_kodelokasi")) ? ReactSession.get("sess_order_kodelokasi") : '',
        };
    }

    open = () => {
        this.setState({ isModalOpen: true, loading: true, search: '' }, () => {
            this.getLokasi();
        });
    };

    handleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    getLokasi = () => {
        Helpers.getListLokasiPengiriman('', this.state.sessEmail, this.state.branchCode).then(res => {
            this.setState({ lokasiData: (res) ? res : [], loading: false });
        });
    };

    handleSelect = (object) => {
        const check_jarak = (parseFloat(object.Jarak) / 1000).toFixed(2);
        if (check_jarak > 200) {
            toast.error(Helpers.MSG_ERROR_DISTANCE);
            return;
        }

        ReactSession.set("sess_order_kodelokasi", object.KodeLokasi);
        ReactSession.set("sess_order_lokasi_nama", object.Nama);
        ReactSession.set("sess_order_jarak", object.Jarak);
        ReactSession.set("sess_order_penerima", object.Penerima);
        ReactSession.set("sess_order_noponsel", object.NoPonsel);
        ReactSession.set("sess_order_latitude", object.Latitude);
        ReactSession.set("sess_order_longitude", object.Longitude);
        ReactSession.set("sess_order_pinpoint", object.PinPoint);
        ReactSession.set("sess_order_jasakirim", object.EstimasiJasaKirim2);

        window.location.reload();
    };

    render() {
        const filtered = this.state.lokasiData.filter((object) => {
            if (!this.state.search) return true;
            return (object.Nama || '').toUpperCase().indexOf(this.state.search.toUpperCase()) !== -1;
        });

        return (
            <Modal
                size={'md'}
                isOpen={this.state.isModalOpen}
                toggle={() => { this.handleModal() }}
                contentClassName="modal-picker-content">
                <ModalBody className="modal-picker-body">
                    <div className="modal-picker-header">
                        <div className="modal-picker-title">
                            <span className="modal-picker-icon"><i className="fi-rs-marker"></i></span>
                            Pilih Lokasi Pengiriman
                        </div>
                        <button type="button" className="modal-picker-close" onClick={() => { this.handleModal() }} aria-label="Tutup">
                            <i className="fi-rs-cross"></i>
                        </button>
                    </div>

                    <div className="modal-picker-search">
                        <i className="fi-rs-search"></i>
                        <input
                            type="text"
                            placeholder="Cari lokasi ..."
                            value={this.state.search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                        />
                        <a href={'./location-manage?trxid=&action=insert'} className="modal-picker-add-btn">
                            <i className="fi-rs-plus"></i> Tambah
                        </a>
                    </div>

                    <div className="modal-picker-list">
                        {
                            this.state.loading ? (
                                <div className="modal-picker-empty">
                                    <div className="modal-picker-spinner"></div>
                                    <p>Memuat data lokasi...</p>
                                </div>
                            ) : filtered.length > 0 ? (
                                filtered.map((object, i) => {
                                    const active = object.KodeLokasi === this.state.kodeLokasi;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-lokasi' + (active ? ' active' : '')}
                                            onClick={() => { this.handleSelect(object) }}
                                        >
                                            <span className="modal-picker-item-icon">
                                                <i className="fi-rs-marker"></i>
                                            </span>
                                            <span className="modal-picker-item-text">
                                                <span className="modal-picker-item-title">{object.Nama}</span>
                                                <span className="modal-picker-item-subtitle">{object.Penerima} &middot; {object.NoPonsel}</span>
                                                <span className="modal-picker-item-address">{object.PinPoint}</span>
                                            </span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="modal-picker-empty">
                                    <i className="fi-rs-marker" style={{ fontSize: '30px', color: '#ddd' }}></i>
                                    <p>Belum ada lokasi pengiriman</p>
                                    <a href={'./location-manage?trxid=&action=insert'} className="btn btn-sm">Tambah Lokasi</a>
                                </div>
                            )
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalLokasi;
